export default function flexCenter() {
  return /*css*/`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  `;
}